import Image from "next/image"
import { TeamMemberData, IComponentProps, ResourceListData, ArrayItemObject, StrapiResource } from "../../utils/types"
import { FaLinkedinIn, FaInstagram, FaFacebook } from 'react-icons/fa'
import { AiOutlineTwitter, AiOutlineGithub, AiOutlineArrowLeft, AiOutlineClose } from 'react-icons/ai'
import Link from "next/link"
import ArticleModule from "../sections/ArticleModule"

/* REVISIT ALL THE REFERENCES TO ATTRIBUTES FOR THIS ELEMENT */

const ImageEndpoint = process.env.NEXT_PUBLIC_UPLOADS_URL

interface IProps {
  data: TeamMemberData,
  articles: ArrayItemObject<StrapiResource>[]
}

interface IIconMap {
  [key: string]: React.ReactNode
}

const iconMap: IIconMap = {
  LinkedIn: <FaLinkedinIn size={25} color="#1F1A33" />,
  Github: <AiOutlineGithub size={25} color="#1F1A33" />,
  Twitter: <AiOutlineTwitter size={25} color="#1F1A33" />,
  Facebook: <FaFacebook size={25} color="#1F1A33" />,
  Instagram: <FaInstagram size={25} color="#1F1A33" />,
}


const TeamMemberBio = ({ data, articles }: IProps) => {

  // XXX: better handling
  if (!data) {
    return null
  }

  return (
    <div className={`team-bio relative flex flex-col md:flex-row text-primary-blue`}>
      <Link href="/team" passHref>
        <button className="absolute z-[90] top-10 right-10 uppercase font-medium flex items-center gap-3">
          <AiOutlineClose size={25} />
        </button>
      </Link>
      <div className="team-media relative w-full md:w-1/3 flex flex-col justify-start items-center">
        { data.photo && data.photo.data ? 
            <div className="team-image relative md:h-[calc(100vh_-_3.8rem)]">
              <Image src={`${ImageEndpoint}${data.photo.data.attributes.url}`} alt={data.name} layout="fill" objectFit="cover" />
            </div>
           : null
        }
      </div>
      <div className="flex flex-col gap-3 relative team-bio w-full md:w-2/3 p-10 md:p-20 md:py-12 font-medium text-xl md:max-h-[calc(100vh_-_3.8rem)] md:overflow-y-scroll hide-scrollbar">
        <h2 className="text-[2.7rem] font-extrabold">{data.name}</h2>
        <h3 className="text-gray-700 text-[1.7rem]">{data.jobTitle}</h3>
        {data.externalLinks.length ? 
          <div className="socials md:hidden w-full">
            <ul className="flex gap-3 py-4">
              {data.externalLinks.map((item, index) => (
                <li key={index}>
                  <Link href={item.URL}>
                    <a target="_blank">{iconMap[item.Icon]}</a>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          :
          null
        }
        <div className="text-lg lg:text-xl" dangerouslySetInnerHTML={{__html: data.description}} />
        {data.externalLinks.length ? 
          <div className="socials hidden md:block w-full">
            <ul className="flex gap-3 py-4">
              {data.externalLinks.map((item, index) => (
                <li key={index}>
                  <Link href={item.URL}>
                    <a target="_blank">{iconMap[item.Icon]}</a>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          :
          null
        }
        {articles.length ? 
          <div className="pt-10">
            <ArticleModule limit={3} data={{
              resources: {
                data: articles
              }
            } as ResourceListData} noMargin={true} />
          </div>
          :
          null
        }
      </div>
    </div>
  )
}

export default TeamMemberBio